import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderIcon,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../_metronic/_partials/controls';
import { Dashboard } from '../../_metronic/_partials/dashboards/Dashboard';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { baseUrl, publicUrl } from '../../redux/my-axios';
import Html from '../components/Html';
import css from './style.module.css';

export function DashboardPage({ history }) {
  const [title, setTitle] = useState('Dashboard');
  const [loading, setLoading] = useState(false);
  const [showHoroscope, setShowHoroscope] = useState(false);
  const [horoscope, setHoroscope] = useState('');

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/user-profile`)
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('GetUserProfile: ', response.data.data);
            let user = response.data.data;
            setLoading(false);
            break;
          default:
            console.log('GetUserProfile Error: ', response.data);
            //setShowHoroscope(false);
            onLogin();
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        console.log(error);
        onLogin();
        setLoading(false);
      });
    return function cleanup() {
      setHoroscope('');
      setShowHoroscope(false);
    };
  }, []);

  const onLogin = () => {
    history.push(`/logout`);
  };

  const MyHtml = () => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: horoscope,
        }}
      ></div>
    );
  };

  const DirectPage = () => {
    return <div></div>;
    {
      /* <iframe
        src={`${publicUrl}/horoscope`}
        style={{ width: '100%', height: '100%' }}
      /> */
    }
  };

  return (
    <>
      <Dashboard />
      {/* <Modal.Body className='overlay overlay-block cursor-default'>
        {loading && <ModalProgressBar />}
        {loading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          <CardBody>
            <div className={css.main}>
              
            </div>
          </CardBody>
        </Card>
      </Modal.Body> */}
    </>
  );
}
